import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Card,
  Select,
} from 'antd';
import {
  OnwerInfoForm,
  ConfigLoanCard,
  BadesulLineTerms,
} from 'components';
import { badesulProductOptions } from 'utils';
import './styles.less';

const UserAndLoanStep = ({
  form,
  withLoanCreation,
  setInstallmentsCount,
  setAmount,
  showBadesulProducts,
  portfolioName,
  setPortfolioName,
  isBadesulProduct,
  termAcknowledged,
  setTermAcknowledged,
}) => (
  <Row align="middle" justify={withLoanCreation ? 'space-around' : 'center'} gutter={[16, 24]} id="user-and-loan-step">
    <Col xs={24} sm={24} md={24} lg={10} xl={8}>
      <Card>
        <div className="card-header">
          <h3>Dados do sócio principal</h3>
        </div>
        <OnwerInfoForm form={form} />
      </Card>
    </Col>
    {withLoanCreation && (
    <Col xs={24} sm={24} md={24} lg={12}>
      {showBadesulProducts && (
        <>
          <h6 className="no-margin-bottom">
            <b className="secondary-text">Produto do empréstimo *</b>
          </h6>
          <Select
            className="gyramais-input"
            id="badesul-product-select"
            placeholder="Selecione o produto"
            style={{ width: '100%', marginBottom: 16 }}
            value={portfolioName}
            onChange={(value) => setPortfolioName(value)}
            options={badesulProductOptions}
          />
        </>
      )}
      {isBadesulProduct ? (
        <>
          <p className="secondary-text">
            O valor e o prazo do empréstimo Badesul são definidos na etapa de
            pré-aprovação, a partir da análise do Toolbox.
          </p>

          <BadesulLineTerms
            portfolioName={portfolioName}
            acknowledged={termAcknowledged}
            onAcknowledgedChange={setTermAcknowledged}
          />
        </>
      ) : (
        <ConfigLoanCard
          onChangeAmount={(e) => setAmount(e)}
          onChangeInstallmentsCount={(e) => setInstallmentsCount(e)}
        />
      )}
    </Col>
    )}
  </Row>
);

UserAndLoanStep.propTypes = {
  form: PropTypes.shape(),
  withLoanCreation: PropTypes.bool,
  setInstallmentsCount: PropTypes.func,
  setAmount: PropTypes.func,
  showBadesulProducts: PropTypes.bool,
  portfolioName: PropTypes.string,
  setPortfolioName: PropTypes.func,
  isBadesulProduct: PropTypes.bool,
  termAcknowledged: PropTypes.bool,
  setTermAcknowledged: PropTypes.func,
};

export default UserAndLoanStep;
